module.exports = __webpack_public_path__ + "static/media/pharmaflexrx-logo.4fd7689f.png";